 import * as mdb from 'mdb-ui-kit/js/mdb.umd.min.js';
window.mdb = mdb;
window.Chart = mdb.Chart;
window.Sidenav = mdb.Sidenav;
window.Toast = mdb.Toast;
